import React from 'react';
import { ThemeProvider } from 'styled-components';
import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import 'react-calendar/dist/Calendar.css';
import "react-datepicker/dist/react-datepicker.css";

import { theme } from './app/modules/ThemeModule'
import { AuthProvider } from './app/contexts/AuthContext';
import { WaitingBox } from './app/common-components/WaitingBox/WaitingBox';
import { AppRoutes } from './app/routes/AppRoutes';

import moment from 'moment-timezone';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import ptBR from 'date-fns/locale/pt-BR';
import numeral from 'numeral';

moment.tz.setDefault("America/Sao_Paulo");
registerLocale('ptBR', ptBR)
setDefaultLocale('ptBR');

numeral.register('locale', 'pt-BR', {
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  abbreviations: {
    thousand: '',
    million: '',
    billion: '',
    trillion: ''
  },
  ordinal: function (number) {
    return '';
  },
  currency: {
    symbol: 'R$'
  }
});
numeral.locale('pt-BR');

export const App: React.FC = () => {

  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
      <ToastContainer />
      <WaitingBox />
    </ThemeProvider>
  );
}